import { put, takeEvery } from "redux-saga/effects";

import { loading } from "layouts/AppLayout/modules";
import { AUTH_UNLINK_REQUEST } from "../actions/AuthUnlink";

export function* unlinkRequest() {
    try {
        yield put(loading(true, AUTH_UNLINK_REQUEST));
    } catch (error) {
        console.error("Unlink Request", error);
    } finally {
        yield put(loading(false, AUTH_UNLINK_REQUEST));
    }
}

export function* watchUnlink() {
    yield takeEvery(AUTH_UNLINK_REQUEST, unlinkRequest);
}
